// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__BCCME","disabled":"FileBtn_disabled__13maG","warn":"FileBtn_warn__2KXbY","fade":"FileBtn_fade__2BBRL"};